import { gql } from '@apollo/client';

/**
 * GraphQL query for listing jobs from pg-boss queue
 * Feature: 073-job-queue-inspector
 */
export const ADMIN_JOBS_QUERY = gql`
  query AdminJobs(
    $page: Int
    $limit: Int
    $filters: JobFiltersInput
    $sortBy: String
    $sortOrder: SortDirection
  ) {
    adminJobs(
      page: $page
      limit: $limit
      filters: $filters
      sortBy: $sortBy
      sortOrder: $sortOrder
    ) {
      jobs {
        id
        name
        state
        status
        priority
        retryCount
        retryLimit
        retryDelay
        retryBackoff
        createdOn
        startedOn
        completedOn
        startAfter
        keepUntil
        age
        duration
      }
      total
      page
      pageSize
      hasMore
    }
  }
`;

/**
 * GraphQL query for individual job details with full data/output
 * Feature: 073-job-queue-inspector
 */
export const ADMIN_JOB_DETAIL_QUERY = gql`
  query AdminJobDetail($id: String!) {
    adminJobDetail(id: $id) {
      id
      name
      state
      status
      priority
      retryCount
      retryLimit
      retryDelay
      retryBackoff
      createdOn
      startedOn
      completedOn
      startAfter
      keepUntil
      age
      duration
      data
      output
    }
  }
`;
